import { Typography } from '@mui/material';
import { ALERT_DIALOG_TAG_TYPE_CHANGE_CONTENT } from '../../config';

export const AlertDialogTagTypeChangeContent = () => (
  <>
    <Typography color="text.secondary">{ALERT_DIALOG_TAG_TYPE_CHANGE_CONTENT}</Typography>
  </>
);
